module.exports = __webpack_public_path__ + "static/img/shuzijishu-1.f25f0cd2.svg";